import { createContext } from "react";
import { allElements } from "constants/constants";
import { DEFAULT_OEE_DATE_PRESET, resolveOeeDatePreset } from "utilities/oeeDateRange";
import { IOeeSummaryDashboardContext, IOeeSummaryDashboardFilters } from "./OeeSummaryDashboardContextInterfaces";

export const initialOeeSummaryDashboardFilters: IOeeSummaryDashboardFilters = {
    machineCenter: [allElements],
    productionLine: allElements,
    shift: allElements,
};

/** Filters saved as the user's default; the production line and the date range are never saved. */
export const validOeeSummaryDefaultFields = ["machineCenter", "shift"];

export const initialState: IOeeSummaryDashboardContext = {
    datePreset: DEFAULT_OEE_DATE_PRESET,
    dateRange: resolveOeeDatePreset(DEFAULT_OEE_DATE_PRESET),
    filters: initialOeeSummaryDashboardFilters,
    handleDatePresetChange: () => {},
    handleFiltersChange: () => {},
    handleRemoveDefaultFilters: async () => {},
    handleSelectedProductionLineChange: () => {},
    handleSetFiltersDefault: async () => {},
    handleShowAllProductionLinesChange: () => {},
    handleShowFiltersChange: () => {},
    loadingDefaultOperations: false,
    selectedProductionLineName: "",
    showAllProductionLines: true,
    showFilters: false,
    userFiltersDefault: null,
};

export const OeeSummaryDashboardContext = createContext(initialState);
